import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

import { TmsWebBaseService } from 'tms-web-shared';
import {
  ProductionPlanAvailability,
  ProductionPlanBoard,
  ProductionPlanDayHours,
  ProductionPlanMove,
  ProductionPlanShiftPattern,
} from '../../../models';

@Injectable({
  providedIn: 'root',
})
// The loom production plan (PRD production-planning). Every change reschedules on the API
// before it answers, so the next read is already the new plan - and `planChanged` tells the
// board and the availability calendar to read it.
export class ProductionPlanService extends TmsWebBaseService {
  public readonly planChanged = new Subject<void>();

  constructor() {
    super('ProductionPlan');
  }

  getBoard(fromDate: string, days: number): Observable<ProductionPlanBoard> {
    return this.httpService.get<ProductionPlanBoard>(`${this.apiUrl}/Board?fromDate=${fromDate}&days=${days}`);
  }

  getAvailability(machineId: string, year: number, month: number): Observable<ProductionPlanAvailability> {
    return this.httpService.get<ProductionPlanAvailability>(
      `${this.apiUrl}/Availability/${machineId}/${year}/${month}`,
    );
  }

  move(model: ProductionPlanMove): Observable<void> {
    return this.httpService.post<void>(`${this.apiUrl}/Move`, model);
  }

  unschedule(jobId: string): Observable<void> {
    return this.httpService.post<void>(`${this.apiUrl}/Unschedule/${jobId}`, {});
  }

  reschedule(): Observable<void> {
    return this.httpService.post<void>(`${this.apiUrl}/Reschedule`, {});
  }

  setDayHours(model: ProductionPlanDayHours): Observable<void> {
    return this.httpService.post<void>(`${this.apiUrl}/SetDayHours`, model);
  }

  applyShiftPattern(model: ProductionPlanShiftPattern): Observable<void> {
    return this.httpService.post<void>(`${this.apiUrl}/ApplyShiftPattern`, model);
  }
}
